import DataService from "../Dataservice";

const params = (query = {}) => {
  const search = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== "" && value !== undefined && value !== null) search.set(key, value);
  });
  return search.toString() ? `?${search.toString()}` : "";
};

const publicGet = async (url) => (await DataService.getWithoutToken(url)).data;
const get = async (url) => (await DataService.get(url)).data;
const post = async (url, data) => (await DataService.post(url, data)).data;
const patch = async (url, data) => (await DataService.patch(url, data)).data;
const del = async (url) => (await DataService.del(url)).data;

const listCategories = (query) => publicGet(`/used_items/categories/${params(query)}`);
const getCategory = (id) => publicGet(`/used_items/categories/${id}/`);
const listItems = (query) => publicGet(`/used_items/items/${params(query)}`);
const getItem = (id) => publicGet(`/used_items/items/${id}/`);
const listPlans = () => get("/used_items/subscriptions/plans/");
const createSubscription = (data) => post("/used_items/subscriptions/", data);
const mySubscriptions = () => get("/used_items/subscriptions/my/");
const mySubscription = (id) => get(`/used_items/subscriptions/my/${id}/`);
const createPayment = (data) => post("/used_items/payments/", data);
const myPayments = (query) => get(`/used_items/payments/my/${params(query)}`);
const myPayment = (id) => get(`/used_items/payments/my/${id}/`);
const createItem = (data) => post("/used_items/items/", data);
const myItems = (query) => get(`/used_items/items/my/${params(query)}`);
const myItem = (id) => get(`/used_items/items/my/${id}/`);
const updateItem = ({ id, ...data }) => patch(`/used_items/items/my/${id}/`, data);
const deleteItem = (id) => del(`/used_items/items/my/${id}/`);
const itemImages = (id) => get(`/used_items/items/my/${id}/images/`);
const addItemImage = ({ id, image }) => post(`/used_items/items/my/${id}/images/`, { image });
const deleteItemImage = ({ itemId, id }) => del(`/used_items/items/my/${itemId}/images/${id}/`);

export {
  listCategories, getCategory, listItems, getItem, listPlans, createSubscription,
  mySubscriptions, mySubscription, createPayment, myPayments, myPayment, createItem,
  myItems, myItem, updateItem, deleteItem, itemImages, addItemImage, deleteItemImage,
};
